import React, { Component } from 'react'
import { connect } from 'react-redux'
import {Link,Router} from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'
import Paper from '@material-ui/core/Paper';
import ReactPaginate from 'react-paginate';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import * as actionCreators from '../../store/actions/index'
import swal from 'sweetalert'
import OutlinedInput from '@material-ui/core/OutlinedInput';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import Alert from '@material-ui/lab/Alert';
import InputAdornment from '@material-ui/core/InputAdornment';
// import Paper from '@material-ui/core/Paper';
// import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import OperatorForm from './OperatorForm'
import MoreVertOutlinedIcon from '@material-ui/icons/MoreVertOutlined';
import TablePagination from '@material-ui/core/TablePagination'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { DatePicker , MuiPickersUtilsProvider,KeyboardTimePicker,
    KeyboardDatePicker, KeyboardDateTimePicker} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import Card from '../Dashboard/Card/Card.js'
import CardHeader from "../Dashboard/Card/CardHeader.js";
import CardIcon from "../Dashboard/Card/CardIcon.js";
import CardBody from '../Dashboard/Card/CardBody.js'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import moment from 'moment'
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import operatorBulkUploadFile from '../../OperatorBulkUpload.xlsx'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { withTranslation } from 'react-i18next';

const options=[
    {
        "id"  : 1,
        "key" : "Other"
    },
    {
        "id"  : 2,
        "key" : "Vacuum truck with tanker"
    },
    {
        "id"  : 3,
        "key" : "Tractor with tanker"
    },
    {
        "id"  : 4,
        "key" : "Truck with separate tank"
    }
]
const licensedWithULBOptions=[
    {
        "key"    : true,
        "name"   : "Yes"
    },
    {
        "key"    : false,
        "name"   : "No"
    }
]
const gpsInstalledOptions=[
    {
        "key"    : true,
        "name"   : "Yes"
    },
    {
        "key"    : false,
        "name"   : "No"
    }
]
const isDisableTruck=[
    {
        "key"   : false,
        "name"   : "Active"
    },
    {
        "key"    : true,
        "name"   : "In Active"
    }
]
// const options = [
//     'Truck' , 'Edit'
//   ];
export class OperatorListing extends Component {
    state = {
        searchVal : '',
        limit : 10,
        page : 0,
        rowsPerPage : 1,
        // sortObj : {
        //     key : '',
        //     value : ''
        // },
        // page:1,
        // limit:10,
        actionMenuOpen : false,
        addActionData : {},
        anchorEl:null,
        open:false,
        id:'',
        operatorName:'',
        anchorEl_bulk:null,
        placement:'',
        currentSortId:'',
        sortObj : {
            key: '',
            value: ''
        },
        controls: {
            search: {
                value: '',
            }
        },
        openDialog:false,
        username            :                        "",
        password            :   "",   
        operatorId          :             "",
        id                  : "",
        operator                           : "",
        ownerName              : "",
        contactNo              : "",
        email                                : "",
        vehicleOwnerName          : "",
        address             : "",
        noOfTrucks          : '',
        updatedDate         : '',
        name_tn             : "",
        operatorErr         : '',
        ownerNameErr        : '',
        contactNoErr        : '',
        emailErr            : '',
        vehicleOwnerNameErr : '',
        addressErr          : '',
        usernameErr         : '',
        passwordErr         : '',
        registrationNumber:'',
        registrationNumberErr:'',
        vehicleTypeIdErr          : '',
        capacityErr:'',
        RepasswordErr:'',
        licensedWithULBErr:'',
        isPasswordShown: false,
        isRePasswordShown:false,
        StatusValue        :false,
        isStatus      : null,
      
        vehicleTypeId             : '',
       
        capacity:'',
      
        isDisableTruck:'',
        licensedWithULB:'',
     
        ConfirmPassword:'',
        RepasswordError:'',
        RepasswordErr:'',
        selectedDate: moment(new Date()).format("yyyy"),
        openEditOperator:false,

        editoperatorId: '',
        operatorE:"",
        name_tnE:"",
        ownerNameE:"",
        contactNoE:"",
        registrationNumberE:"",
        emailE:"",
        capacityE:"",
        vehicleTypeIdE:"",
        licensedWithULBE:"",
        usernameE:"",
        passwordE:"",
        selectedDate: "",
        statusType:false

    }
    componentDidMount()
    {
        //  window.location.reload(false);
        const payload = {
            token : this.props.token,
            page:this.state.page,
            limit:this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value
        }
        this.props.onFetchOperatorHeaders(payload)
        this.props.onFetchOperatorData(payload)

    }
    // inputChangedHadler = (event) =>
    // {
    //     this.setState({searchVal : event.target.value})
    // }
    // onClickSearch = (event) => 
    // {
    //     event.preventDefault()
    //     const searchVal = this.state.searchVal
    //     if(searchVal.length >= 3 || searchVal.length == 0){
    //         const payload = {
    //             token : this.props.token,
    //             page : 1,
    //             limit : this.state.limit,
    //             sortName:this.state.sortObj.key,
    //             sortValue :this.state.sortObj.value,

    //         }
    //     }else{
    //         swal('String must be atleast 3 characters')
    //     }
    // }
    handleChangePage = (event, newPage) => {
        // setPage(newPage);
        this.setState({page:newPage})
      };
      handleChangeRowsPerPage = (event) => {
        this.setState({limit:parseInt(event.target.value, 10),page:0});
        
      };
    handleActionMenuClicked = (e,dataAction) => {
        this.props.operatorData.map(data => {
            if(data.operatorName == dataAction.operatorName)
            {
                const actionMenu = !data.actionMenu
                return {...data, ...actionMenu}
            }
            else
            {
                
            }
        })
        this.setState((prevState)=>{
            return ({actionMenuOpen : !prevState.actionMenuOpen, addActionData:dataAction })
        })
    }
    handleClickAway = () => {
        this.setState({actionMenuOpen:false})
    }
    // handleSort = (event, sortBy) => {
    //     let sortObj;
    //     if (this.state.sortObj.key === sortBy.accessor) {
    //         let value = (this.state.sortObj.value === '-desc') ? '-asc' : '-desc';
    //         sortObj = {
    //             key : sortBy.accessor,
    //             value: value
    //         }
    //     } 
    //     else {
    //         sortObj = {
    //             key : sortBy.accessor,
    //             value: '-desc'
    //         }    
    //     }
    //     this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
    //     let payload = {
    //         token: this.props.token,
    //         page:  1,
    //         limit: this.state.limit,
    //         sort: `${sortObj.key}${sortObj.value}`,
    //         filter: JSON.stringify([this.state.filter]),
    //         query: this.state.query
    //     }
    //     this.props.onFetchOperatorData(payload);

    // }
    handleClickMoreVertIcon=(event,id, name,  name_tn, ownerName, contactNo, email, vehicleOwnerName, noOfTrucks, username, password, isDisableOperator, capacity, vehicleNo, gpsInstall, License, vehicleType)=>{
      this.setState({open:!this.state.open,anchorEl:event.currentTarget,id:id, operatorName:name,  name_tn, ownerName, contactNo, email, vehicleOwnerName, noOfTrucks, username, password, isDisableOperator, capacity, vehicleNo, gpsInstall, License, vehicleType})
    }
    handleClickAway = () => {
        this.setState({open:false});
    };

    onFileUpload = () => { 
    const payload = {
        token : this.props.token
    }
    const formData = new FormData(); 
    formData.append( 
        "operatorBulkUploadFile", 
        this.state.selectedFile, 
        this.state.selectedFile.name 
    )
    this.props.onFetchOperatorBulkImport(payload,formData);
    this.setState({open_bulk:false})
    }
    onFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0]},()=>{
            this.onFileUpload()
        });   
    }
    handleClose = (event) => {
    this.setState({open_bulk:false})
    };
    handleClick = (newPlacement) => (event) => {
    this.setState({ anchorEl_bulk:event.currentTarget, newPlacement:newPlacement,open_bulk:!this.state.open_bulk});
    };
    handleClickAwayBulk = () => {
        this.setState({
          open_bulk: false 
        });
      };
    handleDelete = (id, t) => {
        const payload = {
            id : id,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            page:1,
            limit:10,
            token: this.props.token,
        }
    const  data= {
        id : id,
    }
        this.props.onDeleteOperator(payload,data, t)
    }


    onClickExport=()=>{
        let payload = {
            page:1,
            limit:10,
            token: this.props.token,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
        }
        this.props.exportData(payload);
       
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        let payload = {
            token: this.props.token,
            page:  selectedPage + 1,
            limit: this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value
        }
        this.props.onFetchOperatorData(payload)
    };


    handleSortheader = (e,sortBy) => {
        let sortObj
        if (this.state.sortObj.key === sortBy.accessor) {
            let value = (this.state.sortObj.value === 'desc') ? 'asc' : 'desc';
            sortObj = {
                key : sortBy.accessor,
                value: value
            }
        } 
        else {
            sortObj = {
                key : sortBy.accessor,
                value: 'desc'
         }    
         }
 
        this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
        let payload = {
            token: this.props.token,
            sortName:sortObj.key,
         sortValue : sortObj.value,
         page: this.state.page,
         limit: this.state.limit,
         searchQuery: this.state.controls.search.value
        }

        this.props.onFetchOperatorData(payload);
  
      }
      
      inputChangedHadler = (event, controlName, t) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
            }
        }
        this.setState({ controls: updatedControls });
        if( updatedControls.search.value === ''){
            let payload = {
                token: this.props.token,
                searchQuery:'',
                limit:this.state.limit,
                page:this.state.page,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
            }
            this.props.onSearchOperterName(payload, t) 
        }
    }
    toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
    handlePropertySearch = (e, t) => {
        e.preventDefault()
        let searchVal = this.state.controls.search.value
        if (!!searchVal && searchVal.length >= 2) {
            let payload = {
                token: this.props.token,
                searchQuery:searchVal,
                limit:10,
                page:this.state.page,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
              
            }
            this.props.onSearchOperterName(payload, t) 
        } else {
         
            swal(`${t("ulbSearch")}`)
        }
    }
    openpopupOperator =()=>{
        this.setState({
            openDialog:true
         })
    }
    handleDialogClose = (value) => {
    this.setState({
        openDialog:value
    }) 

    }
    checkValidity = () => {
        const {t, i18n} = this.props
        let isError = false
      
        if(!this.state.usernameE){
            isError = true
            this.setState({
                usernameErr: `${t("required")}`
            })
        }
        else{
            isError = false
            this.setState({
                usernameErr:''
            })
        }
        if(this.state.usernameE && !this.state.passwordE){
            isError = true
            this.setState({
                passwordErr:`${t("required")}`,
               
            })
        }else{
            isError = false
            this.setState({
                passwordErr:''
            })  
        }
        // if(this.state.password && !this.state.username){
        //     isError = true
        //     this.setState({
        //         usernameErr:'*This field is required'
        //     })
        // }else{
        //     isError = false
        //     this.setState({
        //         usernameErr:''
        //     })  
        // }

        if(this.state.usernameE && this.state.passwordE){
            if(!this.state.passwordE.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
                isError = true
                this.setState({
                    passwordErr:`${t("ulbPassErr")}`
                })   
            }else{
                isError = false
                this.setState({
                    passwordErr:''
                })   
            }
        }


        if (this.state.passwordE && !this.state.ConfirmPassword) {
            isError = false;
            this.setState({
                RepasswordErr:`${t("passMatch1")}`
            }) 
          }
         else if ( this.state.ConfirmPassword !== this.state.passwordE &&  this.state.ConfirmPassword !== this.state.passwordE) {
            isError = false;
            this.setState({
                RepasswordErr:`${t("passMatch2")}`
            }) 
          }else{
            isError = false
            this.setState({
                RepasswordErr:''
            })   
        }
        if(!this.state.operatorE){
            isError=true
            this.setState({operatorErr : `${t("required")}`})
        }
        // else if(!!this.state.operator&&this.state.operator.length > 0 && this.state.operator.length <3 ){
        //     isError=true
        //     this.setState({operatorErr : '*Name should be Minimum 3 characters and Maximum 100 characters'})
        // }
        else if(!!this.state.operatorE && this.state.operatorE.length>=3){
            isError = false
            this.setState({operatorErr:''})
        }
        else{
            if(!!this.state.operatorE&&this.state.operatorE.length > 0 && this.state.operatorE.length <3 ){
                isError=true
                this.setState({operatorErr : `${t('disposalLocalErr')}`})
            }
        }
        if(this.state.ownerNameE.length > 0 && this.state.ownerNameE.length <3){
            isError=true
            this.setState({ownerNameErr : `${t('disposalLocalErr')}`})
        }
        else{
            this.setState({ownerNameErr:''})
        }

        if(!this.state.contactNoE){
            isError=true
            this.setState({contactNoErr:`${t("required")}`})
        }
        else if(this.state.contactNoE){
            if(!this.state.contactNoE.match(/^[0-9]{1,10}$/)){
                isError=true
                this.setState({contactNoErr: `${t("operatorContact")}`})
            }
            else{
                if(this.state.contactNoE.length === 10){
                    isError=false
                    this.setState({contactNoErr:''})
                }
              
            }
     
        }else{
            this.setState({contactNoErr:''})
        }
        // else if(this.state.contactNo && this.state.contactNo.length>=10 && !Number.isNaN(parseInt(this.state.contactNo))) {
        //     this.setState({contactNoErr: ''})
        // }
        if(this.state.emailE){
            var mailformat= /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if(!this.state.emailE.match(mailformat)){
                isError=true
                this.setState({emailErr: `${t("ulbEmailErr")}`})
            }
            else{
                this.setState({emailErr:''})
            }
        }
        else if(!this.state.emailE){
            // isError=false
            this.setState({emailErr : ''})
        }
        // if(this.state.password && !this.props.operatorId){
        //     const passwordFormat = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/
        //     if(!this.state.password.match(passwordFormat)){
        //         isError=true
        //         this.setState({passwordErr:'*Password should be between 8 to 20 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character'})
        //     }else{
        //         isError = false
        //         this.setState({passwordErr : ''})
        //     }
        // }
        // if(!this.state.vehicleOwnerName){
        //     isError=true
        //     this.setState({vehicleOwnerNameErr:'*This field is required'})
        // }
        // else if(this.state.vehicleOwnerName.length>0 && this.state.vehicleOwnerName.length<3 ){
        //     isError=true
        //     this.setState({vehicleOwnerNameErr:"*Name should be Minimum 3 characters and Maximum 100 characters"})
        // }

        
        // else {
        //     this.setState({vehicleOwnerNameErr:''})
        // }


        if(!this.state.registrationNumberE){
            isError=true
            this.setState({registrationNumberErr:`${t("required")}`})
        }
     
        else{
            this.setState({registrationNumberErr:''})
        }

        if(!this.state.vehicleTypeIdE){
            isError=true
            this.setState({vehicleTypeIdErr:`${t("required")}`})
        }
        else{
            this.setState({vehicleTypeIdErr:''})
        }

        if(!this.state.capacityE){
            isError = true
            this.setState({capacityErr:`${t("required")}`})
        }
        else if(this.state.capacityE && this.state.capacityE< 10 || this.state.capacityE > 20000 ){
            isError = true
            this.setState({capacityErr : "10 to 20,000"})
        }
        else if(this.state.capacityE && this.state.capacityE >= 10 || this.state.capacityE <= 20000 ){
            this.setState({capacityErr:''})
        }
        return isError
    }

    

    handleSubmitOperator=(e)=>{
        e.preventDefault()
        const err = this.checkValidity()
        const {t, i18n} = this.props
        if(!err)
        {
            let props=this.props
            const formdata= {
                token            : this.props.token,
                id               : this.state.editoperatorId,
                operator         : this.state.operatorE,
                name_tn          : this.state.name_tnE,
                ownerName        : this.state.ownerNameE,
                contactNo        : this.state.contactNoE,
                email            : this.state.emailE,
                vehicleOwnerName : this.state.vehicleOwnerName,
                noOfTrucks       : this.state.noOfTrucks,
                username         : this.state.usernameE,
                password         : this.state.passwordE,
                isDisableOperator : this.state.statusType,
                capacity : this.state.capacityE,
                vehicleNo:this.state.registrationNumberE,
                gpsInstall : this.state.licensedWithULBE,
                License: this.state.selectedDate,
                vehicleType : this.state.vehicleTypeIdE



            }
            // this.props.handleSubmit(formdata,props)
            this.props.onEditOperatorData(formdata, t)
            // this.handleClose()
            this.handleCloseOperator()
        }
    }
    handleChange = (event) =>{
        this.setState({[event.target.name]:event.target.value}
            , ()=> {
            this.checkValidity()
        }
        )
    }
    ReToggleVisibility=()=>{
        const{isRePasswordShown}=this.state
        this.setState({isRePasswordShown:!isRePasswordShown})
      }
    handleDateChange = (date) => {
        this.setState ({
          selectedDate:date
        })
      }
      handleCloseOperator=()=>{
          this.setState({
            openEditOperator: false, 
            operatorE:"",
            name_tnE:"",
            ownerNameE:"",
            contactNoE:"",
            registrationNumberE:"",
            emailE:"",
            capacityE:"",
            vehicleTypeIdE:"",
            licensedWithULBE:"",
            usernameE:"",
            passwordE:"",
            selectedDate:"",
            ConfirmPassword:'',

            operatorErr         : '',
            ownerNameErr        : '',
            contactNoErr        : '',
            emailErr            : '',
            vehicleOwnerNameErr : '',
            addressErr          : '',
            usernameErr         : '',
            passwordErr         : '',
            registrationNumber:'',
            registrationNumberErr:'',
            vehicleTypeIdErr          : '',
            capacityErr:'',
            RepasswordErr:'',
            licensedWithULBErr:'',
          })
      }
    handleEditOperator=(id, operatorName, name_tn, ownerName,contactNo,email, vehicleOwnerName, noOfTrucks,username, password,isDisableOperator,capacity, vehicleNo, gpsInstall,License,vehicleType)=>{
        this.setState({
            openEditOperator: true, 
            editoperatorId:id,
            operatorE:operatorName,
            name_tnE:name_tn,
            ownerNameE:ownerName,
            contactNoE:contactNo,
            registrationNumberE:vehicleNo,
            emailE:email,
            capacityE:capacity,
            vehicleTypeIdE:vehicleType,
            licensedWithULBE:gpsInstall,
            usernameE:username,
            passwordE:password,
            selectedDate:License,
            statusType: isDisableOperator == "Active"? false : isDisableOperator == "In Active"? true: false


        })
    }
    handlChangeStatus =(e)=>{
        this.setState({isStatus: e.target.value , StatusValue :  e.target.value, StatusValueErr: '',})
    }

    render() {
        const {t, i18n} = this.props
        const checkActionActive = (row) => {
            this.props.operatorData.map(data => {
                
            })
        }
      
        const tableHeaders = this.props.operatorHeaders.map(header => {
            
                return <TableCell className={"white-space"}>
                          
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'start',
                                    whiteSpace: 'break-spaces',
                                    height:'3em'
                                }}>
                                       {header.header}
                    {header.accessor == "actionButton"|| header.header === ""? "":
                    <div onClick={(e) =>  this.handleSortheader(e,header)}>
                        <div>{
                            this.state.currentSortId===header.accessor? this.state.sortObj.value ==='asc'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                        }
                        </div>  
                    </div>}
                              
                                </div>
                           
                    </TableCell>
            })
          
        const tableData = !!this.props.operatorData&&this.props.operatorData.slice(this.state.page * this.state.limit, this.state.page * this.state.limit + this.state.limit).map((data, index) =>   {
        // this.props.operatorData.map(data =>{
                // console.log(data, "GPS INstalled")
                const id = data.operatorId
                let name = data.name
            //    const operator = data.name
               const name_tn   = data["name_tn"]
               const ownerName  = data["applicantName"]
               const contactNo   = data.contactNumber
               const email        = data.email
               const vehicleOwnerName = data.vehicleOwnerName
               const noOfTrucks     = data.noOfTrucks
                const username     = data.username
                const   password    = data.password
                const  isDisableOperator =data.isDisableOperator
                const capacity  = data.capacity
                const  vehicleNo = data.registrationNumber
                const gpsInstall = data.gpsInstalled
                const  License = data.validity
                const   vehicleType  = data.vehicleType
                return <TableRow>
                    {this.props.operatorHeaders.map(header =>
                        {
                            if(header.accessor == "actionButton"){
                                return (
                                <TableCell>  
                                <IconButton
                                    aria-label="more"
                                    aria-controls="long-menu"
                                    aria-haspopup="true"
                                    onClick={(e)=>this.handleClickMoreVertIcon(e,id, name, name_tn, ownerName, contactNo, email, vehicleOwnerName, noOfTrucks, username, password, isDisableOperator, capacity, vehicleNo, gpsInstall, License, vehicleType)}
                                    >
                                    <MoreVertIcon />
                                    </IconButton>
                                     <Popper
                                     open={this.state.open} anchorEl={this.state.anchorEl}>
                                           <ClickAwayListener onClickAway={this.handleClickAway}>
                                        <Paper  style={{boxShadow:"none", border:"1px solid #3dab35"}}>
                                            <MenuList>
                                                {/* <Link to={{ pathname:`/truck-management/${this.state.id}`, state:{ operatorName:this.state.operatorName}}}  className='email_link'> <MenuItem >Truck</MenuItem></Link> */}
                                                {/* <Link to={{ pathname:`/records/${this.state.id}`, state:{ operatorIds:this.state.id, operatorName:this.state.operatorName}}}  className='email_link'> <MenuItem >Loads</MenuItem></Link> */}
                                                <MenuItem style = {{color : '#3dab35'}} className='email_link' onClick={()=>this.handleEditOperator( this.state.id, this.state.operatorName, this.state.name_tn, this.state.ownerName,this.state.contactNo,
                                                    this.state.email, this.state.vehicleOwnerName, this.state.noOfTrucks, this.state.username, 
                                                    this.state.password, this.state.isDisableOperator, this.state.capacity, this.state.vehicleNo, 
                                                    this.state.gpsInstall, this.state.License, this.state.vehicleType)}>{t("edit")}</MenuItem>
                                                {localStorage.getItem('phase2') == 'true' && <div>
                                                <MenuItem style = {{color : '#3dab35'}} onClick = { () => {
                                                    swal({ title   : `${t("ulbDeleteErr1")}`,
                                                           text    : `${t("ulbDeleteErr2")}`,
                                                           icon    : "warning",
                                                           buttons : {
                                                           cancel  : `${t("ulbDeleteErr4")}`,
                                                           confirm : `${t("ulbDeleteErr3")}`}
                                                    })
                                                    .then((willDelete) => {
                                                        if (willDelete) {
                                                            this.handleDelete(this.state.id, t);
                                                        } 
                                                    });
                                                }}>{t("delete")}</MenuItem></div>}
                                            </MenuList>
                                        </Paper>
                                        </ClickAwayListener>
                                    </Popper>
                                </TableCell>
                                )
                            }
                             if(header.accessor=='updatedDate'){
                                   return <TableCell  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word"
                                  }}>{ moment(data[header.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                               }
                              if(header.accessor === "validity"){
                                return <TableCell  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word"
                                  }}>{data[header.accessor] == null? "-": moment(data[header.accessor]).format('YYYY')}</TableCell>
                              } 
                            else{
                                return <TableCell  style={{
                                    whiteSpace: "normal",
                                    // textAlign:'center'
                                    wordWrap: "break-word"
                                  }}>{data[header.accessor]}</TableCell>
                            }
                        })}
                       
                </TableRow>
            })
        return (
            
            <div style={{marginRight:'1%'}}>
                 {/* {(!this.props.loadingOperatorData)&& <div id="cover-spin"></div>} */}
                <Paper elevation={0}>
                <div className="dashboard_right_content">
                        <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                        <div className="dashboard_right_content_top">
                        <h5>{t("operatorInfo")}</h5>
                            <div className="dashboard_right_content_top_options"> 
                          
                              
                            
                            {/* <Button className="email_link"
                                    ref={this.state.anchorRef}
                                    aria-controls={this.state.open ? 'menu-list-grow' : undefined}
                                    aria-haspopup="true"
                                    onClick={this.handleClick('bottom')}
                                    style={{height:'35px',visibility:'hidden'}}
                            >
                                Bulk Import
                                {
                                    this.state.open ?   <ArrowDropUpIcon /> : <ArrowDropDownIcon/> 
                                }
                                
                            </Button> */}
                            {/* <Popper open={this.state.open_bulk} anchorEl={this.state.anchorEl_bulk} placement={this.state.placement} transition>
                            {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={this.handleClickAwayBulk}>
                                <Paper>
                                    <MenuList>
                                    <MenuItem onChange={this.onFileChange}>
                                        <label style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}}> 
                                            <input type="file" style={{display:'none',align:'left'}} /> 
                                          Bulk Upload
                                        </label>
                                    </MenuItem>
                                    <a href={operatorBulkUploadFile} style={{textDecoration:'none', 
                                                                            color:'#3dab35', 
                                                                            fontSize:'small', 
                                                                            fontFamily: "'Open Sans', sans-serif"}} download> 
                                        <MenuItem onClick={this.handleClose}>Download Sample</MenuItem>
                                    </a>
                                    </MenuList>
                                </Paper>
                                </ClickAwayListener>
                            )}
                            </Popper>  */}
                            <div className="dashboard_right_content_top_search">
                                <Paper component="form">
                                    <IconButton aria-label="menu">
                                        <img src="images/search_icon.svg" />
                                    </IconButton>
                                    <InputBase onChange={(event) => this.inputChangedHadler(event, 'search', t)} placeholder={t("operatorName")} />
                                    <Button onClick={(e) => this.handlePropertySearch(e, t)} variant="contained" color="primary" type="submit">{t("search")}</Button>
                                </Paper>
                            </div>
                            <Button  onClick={this.onClickExport}>{t("export")}</Button>
                            <Button className="login_submit" variant="outlined" color="primary" onClick={this.openpopupOperator}>{t("addNewOperator")}</Button>
                            </div>
                        </div>
                    </div>
                   
                    {/* {!!this.props.statisticsData&&this.props.statisticsData.map(data=>
                       (      
                    <Grid container spacing={1}>
                        <Grid item xs={3}>
                            <Card style={{"marginTop": "-10%", padding:"2%"}}>
                            <hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr>  
                            <CardHeader color="warning" stats icon>
                                <CardIcon color="warning" style={{padding: 0}}>
                                <BusinessOutlinedIcon />
                                </CardIcon> 
                                <CardBody>
                                    <h2    style ={{color: "#3dab35",fontSize: "28px",minHeight: "5px",fontWeight: "1000",marginBottom: "10px"}} align="left">{data.operatorCount}</h2>
                                    <h2  style = {{color:"black",fontSize:'small'}} align="left">Operators</h2>
                                </CardBody>          
                            </CardHeader> 
                            </Card>
                        </Grid>   
                        <Grid item xs={3}>
                            <Card style={{"marginTop": "-10%", padding:"2%"}}>
                            <CardHeader color="warning" stats icon>
                                <hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr>
                                <CardIcon color="warning" style={{padding: 0}}>
                                    <LocalShippingOutlinedIcon  />
                                </CardIcon> 
                                    <CardBody>
                                    <h2 style ={{color: "#3dab35",fontSize: "28px",minHeight: "5px",fontWeight: "1000",marginBottom: "10px"}} align="left">
                                        {data.truckCountLicensed}/{data.truckCountUnlicensed}
                                    </h2>
                                    <h2 style = {{color:"black",fontSize:'small'}}  align="left">Licenced Vehicles</h2>
                                    </CardBody>  
                            </CardHeader>
                            </Card>
                        </Grid>
                    </Grid>
                    ))
                  
    } */}
                   
                    <div className="operator_listing" >
                            <TableContainer component={Paper} style={{paddingLeft:"1%", paddingRight:"1%"}}>
                            <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                            {/* <colgroup>
+                                <col style={{width:'3%'}}/>
+                                <col style={{width:'8%'}}/>
+                                <col style={{width:'8%'}}/>
+                                <col style={{width:'15%'}}/>
+                                <col style={{width:'10%'}}/>
+                                <col style={{width:'10%'}}/>
+                                <col style={{width:'10%'}}/>
+                                <col style={{width:'6%'}}/>
+                                <col style={{width:'7%'}}/>
+                                <col style={{width:'10%'}}/>
+                                <col style={{width:'10%',paddingLeft:'0%',paddingRight:'0%'}}/>  
+                            </colgroup> */}
                            <TableHead >
                               <TableRow >
                                    {tableHeaders}
                               </TableRow>
                            </TableHead>
                            <TableBody>
                            {/* {this.props.operatorData.length== 0 && this.props.loadingOperatorData == true? <TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            No Records Found !!</TableRow>: tableData} */}
                                  {tableData}
                            </TableBody>
                            </Table>
                            </TableContainer>
                    </div>
                        {
                        this.props.totalCount && this.props.totalCount != 0 && 
                        // <ReactPaginate
                        // previousLabel={"Prev"}
                        // nextLabel={"Next"}
                        // breakLabel={"..."}
                        // breakClassName={"break-me"}
                        // pageCount = {10}
                        // pageCount = {this.props.totalCount/this.state.limit}
                        // marginPagesDisplayed={2}
                        // pageRangeDisplayed={5}
                        // style={{borderLeftWidth:'0px'}}
                        // onPageChange={this.handlePageClick}
                        // containerClassName={"pagination"}
                        // subContainerClassName={"pages pagination"}
                        // activeClassName={"active"}/>
                        <TablePagination
                        rowsPerPageOptions={[10,50,100]}
                        colSpan={3}
                        count={this.props.totalCount}
                        component="div"
                        rowsPerPage={this.state.limit}
                        page={this.state.page}
                        SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                        }}
                        labelRowsPerPage={t("rowsPerPage")}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                    }
                </Paper>


                <OperatorForm  open={this.state.openDialog} handleClose = {this.handleDialogClose} />







    <div className="">
      <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        // open={true}
        open={this.state.openEditOperator}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{t("editOper")}</span></DialogTitle>
        <DialogContent > 
        <div className="create_ulb_content_outer">
                <div className="create_ulb_content create_ulb_contentPop">
                <div className="operator_listing" >
                <Grid container spacing={1}>
                        <Grid item xs={6}>
                        <FormControl>
                        <label className="required" htmlFor="operator">{t("operName")}</label>
                            <TextField id="operator" 
                                        variant="outlined" 
                                        placeholder={t("phoperName")} 
                                        name="operatorE" 
                                        value={this.state.operatorE} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.operatorErr}</div>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                    
                        <FormControl>
                        <label htmlFor="name_tn">{t("operNameTel")}</label>
                            <TextField id="name_tn" 
                                        variant="outlined" 
                                        placeholder="ఆపరేటర్ పేరును నమోదు చేయండి" 
                                        name="name_tnE" 
                                        value={this.state.name_tnE} 
                                        onChange={this.handleChange}/>
                        
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    <FormControl>
                        <label htmlFor="ownerName">{t("operAppName")}</label>
                            <TextField id="ownerName" 
                                        variant="outlined" 
                                        placeholder={t("phoperAppName")} 
                                        name="ownerNameE" 
                                        value={this.state.ownerNameE} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.ownerNameErr}</div>
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    <FormControl>
                        <label className="required" htmlFor ="contactNo">{t("operContact")}</label>
                            <TextField id = "contactNo" 
                                        variant="outlined" 
                                        placeholder={t("phoperContact")}  
                                        name="contactNoE" 
                                        value={this.state.contactNoE} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.contactNoErr}</div>
                    </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                    <FormControl>
                    <label className="required" htmlFor ="VehicleNo">{t("operVehicle")}</label>
                    <TextField type="text"
                        id="registrationNumber"
                        variant="outlined"
                        size = "small"
                        placeholder ={t("phoperVehicle")}
                        value={this.state.registrationNumberE}
                        name="registrationNumberE"
                        onChange={this.handleChange}
                        InputProps={{ style: { fontSize: 12 } }}/>
                { this.state.registrationNumberErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.registrationNumberErr}</div> : <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required</div>}
                    </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    <FormControl>
                        <label htmlFor = "email">{t("operEmail")}</label>
                            <TextField id = "email" 
                                        variant="outlined" 
                                        placeholder={t("phoperEmail")} 
                                        name="emailE" 
                                        value={this.state.emailE} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.emailErr}</div>
                    </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                            <FormControl>
                            <label className="required" htmlFor ="VehicleNo">{t("operCapacity")}</label>
                            <TextField type="number"
                                id="capacity"
                                variant="outlined"
                                size = "small"
                                placeholder = {t("phoperCapacity")}
                                value={this.state.capacityE}
                                name="capacityE"
                                onChange={this.handleChange}
                                InputProps={{ style: { fontSize: 12, } }}/>
                    {this.state.capacityErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.capacityErr}</div> :  <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required</div>}
                            </FormControl>

                        </Grid>
                    <Grid item xs={6}>
                    <label className="required" htmlFor ="VehicleNo">{t("operVehicletype")}</label>
                    <FormControl variant="outlined" size="small">
                        <Select value={this.state.vehicleTypeIdE} 
                            onChange={this.handleChange} 
                            name="vehicleTypeIdE" 
                            size="small" 
                            style={{fontSize:12,width:'100%'}}>
                            {options.map((option) => (
                                <MenuItem key={option.id}
                                            style={{fontSize:12,width:'100%'}} 
                                            value={option.id}>
                                            {option.key}
                                </MenuItem>
                            ))}
                    </Select>
                        {this.state.vehicleTypeIdErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.vehicleTypeIdErr}</div> :  <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required</div>}
                        </FormControl>
                    </Grid>
                     
                    <Grid item xs={6}>
                        <label htmlFor ="VehicleNo">{t("operGPSIns")}</label>
                        <FormControl variant="outlined" size="small">    
                                            <Select value={this.state.licensedWithULBE} 
                                                    onChange={this.handleChange} 
                                                    name="licensedWithULBE" 
                                                    size="small" 
                                                    style={{fontSize:12,width:'100%'}}>
                                                    {/* {licensedWithULBOptions.map((option) => (
                                                        <MenuItem key={option.key}
                                                                  style={{fontSize:12,width:'100%'}} 
                                                                  value={option.key}
                                                                       
                                                        >
                                                        {option.name}
                                                        {console.log(option.name, "Option Name")}
                                                        </MenuItem>
                                                        
                                                        
                                                    ))} */}
                                                <MenuItem value={"Yes"}>{"Yes"}</MenuItem>
                                                <MenuItem value={"No"}>{"No"}</MenuItem>
                                            </Select>
                                            {this.state.licensedWithULBErr ? <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%",}}>{this.state.licensedWithULBErr}</div> :<div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>required </div> }
                        </FormControl>
                    </Grid>

                        <Grid item xs={6}>
                                <FormControl>
                                    <label className="" htmlFor="statusType" >{t("status")}</label>
                                <TextField id="select"  name="statusType" value={this.state.statusType} onChange = {this.handleChange} select>
                                    <MenuItem value={false}>{'Active'}</MenuItem>
                                    <MenuItem value={true}>{'In Active' }</MenuItem>
                                </TextField>
                                
                                <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.StatusValueErr}</div>
                                </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                        <label htmlFor ="LicenseValidity">{t("operLicenseVal")} </label>
                        <FormControl variant="outlined" size="small" className="style-input">
                        

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker
            format="yyyy"
            margin="normal"
            minDate={moment(new Date()).format("yyyy")}
            id="date-picker-inline"
            //label="Select Date"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            
        />  
        </MuiPickersUtilsProvider>
      
                      
                        </FormControl>
                        </Grid>
                    
               
                   {!this.state.operatorId && <Grid item xs={6}>
                    <FormControl>
                        <label className="required" htmlFor = "username">{t("operUserName")}</label>
                            <TextField id = "username" 
                                        variant="outlined" 
                                        placeholder={t("phoperUserName")} 
                                        name="usernameE" 
                                        value={this.state.usernameE} 
                                        onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.usernameErr}</div>
                    </FormControl>
                    </Grid>}
                    { !this.state.operatorId && <Grid item xs={6}>
                     <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.usernameE ? "required" : ''} htmlFor = "password">{t("operPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("phoperPass")} 
                                      name="passwordE" 
                                      value={this.state.passwordE}
                                      onChange={this.handleChange}
                                      type={this.state.isPasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isPasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.toggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.toggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.passwordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                  </FormControl>
                  </form>
                    </Grid> }

                    <Grid item xs={6}>
                        {/* {
                            this.state.password !=""? */}
                            
                    <form autocomplete="off">
                      <FormControl>
                      <label className={this.state.usernameE ? "required" : ''} htmlFor = "password">{t("operConfirmPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("phoperConfirmPass")} 
                                      name="ConfirmPassword" 
                                      value={this.state.ConfirmPassword}
                                      onChange={this.handleChange}
                                      type={this.state.isRePasswordShown ? "text" : "password"}
                                      endAdornment={this.state.isRePasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{this.ReToggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{this.ReToggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        errortext={this.state.RepasswordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.RepasswordErr}</div>
                  </FormControl>
                  </form> 
         
                    </Grid>

                    
                  
                  
                    </Grid>
                  
                </div>
        
                </div>
            </div>     





             <Grid container spacing={3}>
                        <Grid item xs={12}>
                        <div className="create_ulb_buttons">
                        <Button className="login_submit" variant="outlined" color="primary" onClick={this.handleCloseOperator }>{t("cancel")}</Button>
                        <Button className="login_submit" variant="contained" color="primary" onClick={this.handleSubmitOperator}>{t("saveChange")}</Button>
                    </div>
                        </Grid>
                    </Grid>  
        </DialogContent>
        {/* <DialogActions className="leftp">
            <Button autoFocus onClick={this.handleClosePopHistory} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">Cancel
            </Button>
           
        </DialogActions> */}
    </Dialog>
    </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        operatorHeaders : state.operatorHeaders.operatorHeaders.concat({header: "Action", accessor: "actionButton", sortable: "false", filter: "true"}),
        operatorData : state.operatorData.operatorData,
        statisticsData:state.statisticsData.statisticsData,
        token : state.auth.token,
        totalCount:state.operatorData.totalCount,
        loadingOperatorData: state.operatorData.loading
    }
}

const mapDispatchToProps = (dispatch)=> {
    return{
        onFetchOperatorHeaders : (payload) => dispatch(actionCreators.fetchOperatorHeaders(payload)),
        onFetchOperatorData : (payload) => dispatch(actionCreators.fetchOperatorData(payload)),
        onFetchOperatorBulkImport: (payload,formData) => dispatch(actionCreators.fetchOperatorBulkImport(payload,formData)),
        onDeleteOperator : (payload, data, t) => dispatch(actionCreators.deleteoperator(payload, data, t)),
        exportData: (payload) => dispatch(actionCreators.exportData(payload)),
        onSearchOperterName : (payload, t)=>dispatch(actionCreators.searchOperterName(payload, t)),
        onEditOperatorData: (formdata, t) => dispatch(actionCreators.editOperatorData(formdata, t))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OperatorListing))
